export default __webpack_public_path__ + "static/media/IconTemplatesActive.75a5289c.svg";